export default __webpack_public_path__ + "static/media/plains.e87a2704.svg";